<template>
  <div class="off-bckgr-container-full">
    <my-header
      :page_name="$t('navigation.headerTitles.roleSections')"
      show_usermenu
    ></my-header>
    <div class="settings-line">
      <div class="settings-element">
        <label>{{ $t('roleSections.role') }}</label>
        <el-select
          v-model="roleSelected"
          @change="roleChanged"
          filterable
        >
          <el-option
            v-for="(role, index) in getRolesArray"
            :key="index"
            :value="role.id"
            :label="role.name"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="buttons-grid">
      <!-- <el-button class="el-icon-">Скачать</el-button> -->

      <el-tooltip
        class="item"
        effect="light"
        :content="$t('roleSections.allow')"
        placement="bottom-start"
      >
        <span>
          <el-button
            @click="changeRight('grantRight')"
            class="el-icon-check"
            type="primary"
            :disabled="buttonDisabled"
          ></el-button>
        </span>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="light"
        :content="$t('roleSections.prohibit')"
        placement="bottom-start"
      >
        <span>
          <el-button
            @click="changeRight('revokeRight')"
            class="el-icon-close"
            type="primary"
            :disabled="buttonDisabled"
          ></el-button>
        </span>
      </el-tooltip>

      <el-dropdown trigger="click">
        <el-button
          type="plain"
          size="small"
          class="view-dropdown"
        >
          {{ $t('roleSections.view') }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="optimalViewBtn">{{ $t('roleSections.compact') }}</el-dropdown-item>
          <el-dropdown-item @click.native="fullViewBtn">{{ $t('roleSections.full') }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-row
      type="flex"
      justify="space-between"
      v-if="!gridLoading"
    >
      <el-col
        :span="24"
        class="grid-container-smaller"
      >
        <ag-grid-vue
          style="width: 100%; height: 100%; font-family: 'Open Sans', sans-serif;"
          class="ag-theme-balham"
          :columnDefs="columnDefs"
          :rowData="basesForRole"
          :defaultColDef="defaultColDef"
          rowSelection="multiple"
          :localeText="agGridlocaleText"
          suppressCellSelection
          @grid-ready="onGridReady"
          @first-data-rendered="onGridFirstDataRendered"
          @gridSizeChanged="onGridSizeChanged"
          @column-resized="onColumnResized"
          @row-data-changed="onGridDataChanged"
          @rowSelected="onRowSelected"
        ></ag-grid-vue>
      </el-col>
    </el-row>
  </div>
</template>


<script>
import Header from "../../components/reusable/header/Header";
import agGridLocaleRu from "@/locales/ru/agGrid";
import agGridLocaleUa from "@/locales/ua/agGrid";
import agGridLocaleEn from "@/locales/en/agGrid";
import i18n from "@/locales";
import { AgGridVue } from "ag-grid-vue";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      agGridlocaleText: null,
      columnDefs: null,
      defaultColDef: null,
      gridApi: null,
      columnApi: null,
      settings: null,
      currentRowSelected: null,
      selectedArray: null,
      firstRenderFlag: false,
      gridLoading: true,

      roleSelected: null,
      buttonDisabled: true,
    };
  },
  methods: {
    roleChanged() {
      this.$localStorage.set(
        "wa-sectionRole",
        JSON.stringify(this.roleSelected)
      );
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("getBaseRoleRights", this.roleSelected)
        .then(() => {
          this.gridLoading = false;
          // this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    changeRight(option) {
      this.$store.commit("setLoading", true);
      let array = [];
      this.selectedArray.forEach((base) => {
        array.push({ app: base.appId, db: base.dbId });
      });
      this.$store
        .dispatch("changeRight", {
          funcName: option,
          roleId: this.roleSelected,
          idArray: array,
        })
        .then(() => {
          this.$store.commit("setLoading", false);
          this.buttonDisabled = true;
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    optimalViewBtn() {
      this.gridApi.sizeColumnsToFit();
      this.settings.grids.packs.viewFull = false;
    },
    fullViewBtn() {
      let allColumnIds = [];
      this.columnApi
        .getAllColumns()
        .forEach((column) => allColumnIds.push(column.colId));
      this.columnApi.autoSizeColumns(allColumnIds);
      this.settings.grids.packs.viewFull = true;
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.setEnableCellTextSelection(true);
    },
    onGridSizeChanged(params) {
      params.api.sizeColumnsToFit();
      // this.autoSizeAll();
    },
    onGridDataChanged() {
      if (this.firstRenderFlag) {
        this.$store.commit("setLoading", false);
      }
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    onGridFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
      this.$store.commit("setLoading", false);
      this.firstRenderFlag = true;
    },
    onRowSelected(params) {
      if (params.node.selected) {
        this.currentRowSelected = params.node.data; // текущая выбранная строка грида запоминается в буфере
        this.currentId = Object.values(this.currentRowSelected)[0];
        // console.log("CURRENT ROW: ", this.currentRowSelected);
      }
      if (this.gridApi) {
        this.selectedArray = this.gridApi.getSelectedRows();
      }
      this.buttonDisabled = false;
    },
  },
  created() {
    this.$store.commit("setLoading", true);
    this.$store
      .dispatch("getRoles")
      .then(() => {
        if (this.$localStorage.get("wa-sectionRole")) {
          let role = JSON.parse(this.$localStorage.get("wa-sectionRole"));
          if (this.getRolesArray.find((el) => el.id === role)) {
            this.roleSelected = role;
            this.roleChanged();
          } else this.roleSelected = null;
        } else {
          this.$store.commit("setLoading", false);
        }
      })
      .catch(() => {
        this.$store.commit("setLoading", false);
      });
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: this.$t('roleSections.tableHeaders.access'),
        field: "dbRight",
        valueGetter: (params) =>
          params.data.dbRight === "1" ? this.$t('roleSections.tableHeaders.available') : "-",
        cellClass: "center-column",
      },
      {
        headerName: this.$t('roleSections.tableHeaders.base'),
        field: "dbName",
      },
      {
        headerName: this.$t('roleSections.tableHeaders.baseAlias'),
        field: "dbAlias",
        width: 90,
      },
      {
        headerName: this.$t('roleSections.tableHeaders.baseComment'),
        field: "dbComment",
        width: 90,
      },
      {
        headerName: this.$t('roleSections.tableHeaders.app'),
        field: "appName",
      },
      {
        headerName: this.$t('roleSections.tableHeaders.appAlias'),
        field: "appAlias",
      },
      {
        headerName: this.$t('roleSections.tableHeaders.appServer'),
        field: "appServer",
        cellClass: "center-column",
      },
    ];
    const locale = i18n.locale;
    switch (locale) {
      case "ru":
        this.agGridlocaleText = agGridLocaleRu;
        break;
      case "ua":
        this.agGridlocaleText = agGridLocaleUa;
        break;
      case "en":
        this.agGridlocaleText = agGridLocaleEn;
        break;
      default:
        this.agGridlocaleText = agGridLocaleRu;
    }

    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      autoHeight: true,
    };
    this.settings = {
      grids: {
        packs: {
          viewFull: false,
        },
      },
    };
  },
  watch: {
    basesForRole() {
      if (this.gridApi) this.gridApi.refreshCells(); // обновление данных
    },
  },
  computed: {
    ...mapGetters(["getRolesArray", "basesForRole"]),
  },
  components: {
    myHeader: Header,
    AgGridVue,
  },
};
</script>
